import { render, staticRenderFns } from "./biaoshi.vue?vue&type=template&id=d3692ed2&scoped=true"
import script from "./biaoshi.vue?vue&type=script&lang=js"
export * from "./biaoshi.vue?vue&type=script&lang=js"
import style0 from "./biaoshi.vue?vue&type=style&index=0&id=d3692ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3692ed2",
  null
  
)

export default component.exports